module.exports = __webpack_public_path__ + "static/sport/boxtop.a01b405.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newldp/boxtop.png
// module id = QwSn
// module chunks = 0